import { Component, Input } from "@angular/core";
import { PreviewChip } from "../card-types";
import { defaultPreviewChips, defaultSubtitle } from "./unlock-360-banner.data";

@Component({
  selector: "unlock-360-banner",
  templateUrl: "./unlock-360-banner.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class Unlock360BannerComponent {
  @Input() subtitle: string = defaultSubtitle;
  @Input() previewChips: PreviewChip[] = defaultPreviewChips;
}
